// src/app/models/notification.model.ts
export enum NotificationType {
  Transaction = 0,
  Msg = 1,
  Table = 2,
  Chart = 3
}

export interface NotificationItem {
  notificationID: number;
  title: string;
  body: string;
  type: number;
  created: string;
  senderUserID: number;
  apnsPriority: number;
  readAt?: string | null;
  isRead: boolean;
  transactionStatus?: number;
}

export interface NotificationTypeInfo {
  nameKey: string;
  color: string;
  icon: string;
}

export interface NotificationSummary {
  type: NotificationType;
  typeNameKey: string;
  count: number;
  unreadCount?: number;
  importedCount?: number;
  icon: string;
  color: string;
  route: string;
}

export interface NotificationOverview {
  recentNotifications: NotificationItem[];
  notificationSummary: Array<Pick<NotificationSummary, 'type' | 'count' | 'importedCount'>>;
}
export const NOTIFICATION_SUMMARY_CONFIG: Omit<NotificationSummary, 'count'>[] = [
  {
    type: NotificationType.Transaction,
    typeNameKey: 'MAINPAGE.TRANSACTIONS',
    icon: 'credit_card',
    color: '#6f42c1',
    route: '/transaction'
  },
  {
    type: NotificationType.Msg,
    typeNameKey: 'MAINPAGE.MESSAGES',
    icon: 'mail',
    color: '#007bff',
    route: '/message'
  },
  {
    type: NotificationType.Table,
    typeNameKey: 'MAINPAGE.TABLES',
    icon: 'table_chart',
    color: '#fd7e14',
    route: '/table'
  },
  {
    type: NotificationType.Chart,
    typeNameKey: 'MAINPAGE.CHARTS',
    icon: 'bar_chart',
    color: '#28a745',
    route: '/chart'
  }
];

export function getNotificationSummaryConfig(): NotificationSummary[] {
  return NOTIFICATION_SUMMARY_CONFIG.map(cfg => ({
    ...cfg,
    count: 0,
    unreadCount: 0
  }));
}

export const NOTIFICATION_TYPE_MAP: Record<NotificationType, NotificationTypeInfo> = {
  [NotificationType.Transaction]: { nameKey: 'NOTIFICATION.TRANSACTION', color: '#6f42c1', icon: 'credit_card' },
  [NotificationType.Msg]:         { nameKey: 'NOTIFICATION.MSG',         color: '#007bff', icon: 'mail' },
  [NotificationType.Table]:       { nameKey: 'NOTIFICATION.TABLE',       color: '#fd7e14', icon: 'table_chart' },
  [NotificationType.Chart]:       { nameKey: 'NOTIFICATION.CHART',       color: '#28a745', icon: 'bar_chart' },
};

export const DEFAULT_NOTIFICATION_TYPE_INFO: NotificationTypeInfo = {
  nameKey: 'NOTIFICATION.UNKNOWN',
  color: '#6c757d',
  icon: 'help'
};

export function getNotificationTypeInfo(type: number | NotificationType): NotificationTypeInfo {
  const key = Number(type) as NotificationType;
  return NOTIFICATION_TYPE_MAP[key] ?? DEFAULT_NOTIFICATION_TYPE_INFO;
}
